import { ListMetaNetworkParams } from '../list-conductor/list-meta-data';
import { appConfig } from '../request/app.config';
import { NetworkRequestOptions } from '../request/interfaces/request-options';
import { courierService } from '../request/services/courier.service';
import {
  JobDetailsFactory,
  JobListWithCountFactory,
  JobObjectFailuresFactory,
  JobObjectsWithCountFactory,
  JobSessionLogTaskResFactory,
  PipelineJobListWithCountFactory
} from './factory';
import { JobObjectFailureStage } from './interfaces/job';

export const JobsAPI = {
  jobsURL: appConfig.getJobsURL(),
  failureHandlingURL: appConfig.getFailureHandlingURL(),

  getAllJobs(paginationData: ListMetaNetworkParams | undefined) {
    const requestURL = `${this.jobsURL}`;

    return courierService
      .post(requestURL, { ...paginationData })
      .then(res => JobListWithCountFactory(res));
  },

  getPipelineJobs(integrationId: number, paginationData: ListMetaNetworkParams | undefined) {
    const requestURL = `${this.jobsURL}/integration/${integrationId}`;

    return courierService
      .post(requestURL, { ...paginationData })
      .then(res => PipelineJobListWithCountFactory(res));
  },

  getJobObjects(jobId: string, paginationData: ListMetaNetworkParams | undefined) {
    const requestURL = `${this.jobsURL}/${jobId}/source-object`;

    return courierService
      .post(requestURL, { ...paginationData })
      .then(res => JobObjectsWithCountFactory(res));
  },

  getJobDetails(jobId: string) {
    const requestURL = `${this.jobsURL}/${jobId}`;

    return courierService.get(requestURL).then(res => JobDetailsFactory(res.data));
  },

  getObjectLevelFailures(
    jobId: string,
    objectId: string,
    source: JobObjectFailureStage,
    paginationData: ListMetaNetworkParams | undefined
  ) {
    const requestURL = `${this.failureHandlingURL}/batch/${jobId}/source-object/${objectId}`;

    const options: NetworkRequestOptions = {
      networkOptions: {
        params: {
          page: paginationData?.page as number,
          limit: paginationData?.limit as number,
          source
        }
      }
    };

    return courierService.get(requestURL, options).then(res => JobObjectFailuresFactory(res));
  },

  downloadFailureFile(failureId: string) {
    return courierService.get(`${this.failureHandlingURL}/${failureId}/download`, {
      networkOptions: {
        responseType: 'arraybuffer'
      }
    });
  },
  getJobFailures(jobId: string) {
    return courierService.get(`${this.failureHandlingURL}/batch/${jobId}`, {
      networkOptions: {
        params: new URLSearchParams({ no_source_objects_attached: 'true' })
      }
    });
  },

  cancelJob(jobId: string | number) {
    return courierService.post(`${this.jobsURL}/${jobId}/cancel`, {});
  },

  getJobDownloadLogStatus(jobId: string) {
    return courierService
      .get(`${this.jobsURL}/${jobId}/actions/download-session-logs/status`)
      .then(res => {
        return JobSessionLogTaskResFactory(res.data);
      });
  },

  initiateJobSessionLogDownload(pipelineId: number, jobId: string) {
    return courierService.put(`${this.jobsURL}/${jobId}/actions/download-session-logs`, {
      integration_id: pipelineId
    });
  }
};
